export default {
  metadata: {
    version: '1.0.0',
    id: 'radio-button-1.0.0',
    name: 'JDSRadioButton',
    description:
      'Radio buttons are used when there is alist of two or more options that are mutually exclusive and the user must select exactly one choice.',
    usage: ''
  },
  hierarchy: {
    'vertical-container': [
      {
        'horizontal-container': [
          {
            'outer-container': ['inner-container']
          },
          'label-jds-text'
        ]
      },
      'jds_feedback_block',
      'helper-jds-text'
    ]
  },
  base: {
    'vertical-container': {
      hidden: false,
      'flex-direction': '{r_0}',
      'justify-content': '{r_1}',
      'align-items': '{r_2}',
      gap: '{r_3}',
      opacity: '{r_36}'
    },
    'horizontal-container': {
      hidden: false,
      'flex-direction': '{r_4}',
      'justify-content': '{r_5}',
      'align-items': '{r_6}',
      gap: '{r_7}',
      behavior: {
        hover: {},
        active: {},
        focus: {}
      }
    },
    'outer-container': {
      hidden: false,
      'min-width': '{r_8}',
      'min-height': '{r_9}',
      'flex-direction': '{r_10}',
      'justify-content': '{r_11}',
      'align-items': '{r_12}',
      'background-color': '{r_13}',
      'border-radius': '{r_14}',
      'border-width': '{r_16}',
      'border-color': '{r_15}',
      show: true,
      behavior: {
        hover: {
          'border-color': '{r_18}'
        },
        active: {
          'border-color': '{r_19}'
        },
        focus: {
          'border-width': 4,
          'box-sizing': 'content-box',
          'border-color': '{r_20}'
        }
      }
    },
    'inner-container': {
      hidden: true,
      'min-width': '{r_21}',
      'min-height': '{r_22}',
      'border-radius': '{r_23}',
      show: true
    },
    jds_feedback_block: {
      size: 'l'
    },
    'label-jds-text': {
      'font-family': '{text_132}',
      color: '{text_21}',
      'font-size': '{text_131}',
      'line-height': '{text_133}',
      'letter-spacing': '{text_134}',
      'font-weight': '{text_135}',
      'text-decoration': '{text_7}',
      'text-transform': '{text_base_text_text-transform}',
      'text-align': '{r_24}',
      behavior: {
        hover: {
          color: '{text_20}'
        },
        focus: {
          color: '{text_20}'
        }
      }
    },
    'helper-jds-text': {
      'font-family': '{text_132}',
      color: '{text_21}',
      'font-size': '{text_131}',
      'line-height': '{text_133}',
      'letter-spacing': '{text_134}',
      'font-weight': '{text_135}',
      'text-decoration': '{text_7}',
      'text-transform': '{text_base_text_text-transform}'
    }
  },
  variant: {
    size: {
      small: {
        'outer-container': {
          'min-width': '{r_25}',
          'min-height': '{r_26}'
        },
        'vertical-container': {
          gap: '{r_27}'
        },
        'inner-container': {
          'min-width': '{r_28}',
          'min-height': '{r_29}'
        },
        jds_feedback_block: {
          size: 's'
        },
        'label-jds-text': {
          'font-family': '{text_147}',
          'font-size': '{text_146}',
          'line-height': '{text_148}',
          'letter-spacing': '{text_149}',
          'font-weight': '{text_150}'
        },
        'helper-jds-text': {
          'font-family': '{text_147}',
          'font-size': '{text_146}',
          'line-height': '{text_148}',
          'letter-spacing': '{text_149}',
          'font-weight': '{text_150}'
        }
      }
    },
    checked: {
      true: {
        'outer-container': {
          'background-color': '{r_30}',
          'border-width': '{r_17}',
          behavior: {
            hover: {
              'background-color': '{r_31}'
            },
            active: {
              'background-color': '{r_32}'
            },
            focus: {
              'background-color': '{r_33}'
            }
          }
        },
        'inner-container': {
          hidden: false,
          'background-color': '{r_34}'
        },
        'label-jds-text': {
          color: '{text_20}'
        }
      }
    },
    disabled: {
      true: {
        'vertical-container': {
          opacity: '{r_35}'
        },
        'horizontal-container': {
          disabled: true
        }
      }
    }
  },
  api: {
    config: {
      checked: {
        values: [false, true],
        doc_description: 'Used to programatically make input active/inactive.'
      },
      size: {
        values: ['medium', 'small']
      },
      disabled: {
        values: [false, true]
      }
    },
    data: {
      jds_feedback_block: {
        stateText: {
          type: 'string',
          name: 'stateText'
        },
        state: {
          type: 'JDSFeedbackBlock.state',
          name: 'state'
        }
      },
      'label-jds-text': {
        value: {
          type: 'string',
          name: 'label'
        }
      },
      'helper-jds-text': {
        value: {
          type: 'string',
          name: 'helperText'
        }
      }
    },
    events: {
      'horizontal-container': {
        onClick: 'onClick'
      }
    },
    a11y: {
      'vertical-container': {
        properties: {
          role: {
            value: 'radio'
          },
          'aria-label': {
            name: 'ariaLabel',
            prop: 'label'
          },
          'aria-describedby': {
            name: 'ariaDescribedby',
            platform: 'web,ios'
          },
          'aria-checked': {
            name: '_ariaChecked',
            prop: 'checked'
          }
        }
      }
    }
  }
};
